import Widgets from 'js-widget-hooks';
import app from '../components/app';

Widgets.register('active-center', function(elem){
    let center = JSON.parse(elem.dataset.center);

    app.setState({
        active_center: center,
        current_center: center.slug
    });
});